/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import moment from 'moment';
import { Box, Chip, Typography } from '@mui/material';
import { CATEGORIA_CHART_COLORS, CATEGORIA_STAT_COLORS, formatBRL } from './constants';

export const formatTransactionDate = (value) => {
  if (value == null) return '—';
  const m = moment(value);
  return m.isValid() ? m.format('DD/MM/YYYY') : '—';
};

export const renderCategoriaCell = (categoria) => {
  const label = categoria || '—';
  const colorKey = CATEGORIA_STAT_COLORS[label] || 'default';
  const chipColor =
    colorKey === 'default' ? 'default' : colorKey;

  return (
    <Chip
      label={label}
      size="small"
      color={chipColor}
      variant="outlined"
      sx={{
        borderColor: CATEGORIA_CHART_COLORS[label] || undefined,
        color: CATEGORIA_CHART_COLORS[label] || undefined,
        fontWeight: 600,
      }}
    />
  );
};

export const renderValorCell = (valor) => (
  <Typography variant="body2" sx={{ fontWeight: 600, width: '100%', textAlign: 'right' }}>
    {formatBRL(valor)}
  </Typography>
);

export const renderDescricaoCell = (descricao) => (
  <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: 1.4 }}>
    {descricao || '—'}
  </Box>
);
